import { useRef } from 'react';
import { useSelector } from 'react-redux';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';

import { IState } from 'store';
import { IConfigApplicationProps } from 'store/modules/config';

import CardsList from 'components/common/CardsList';

import * as S from './styles';

export function ProductImagesCarousel({
  productName,
  images,
  productSelosSecondary,
  seloCimed,
  ultraDesconto,
  freteGratis,
  setShowModalAboutFreeFreight,
}) {
  const swiperRef = useRef(null);

  const { ultraDescontao } = useSelector<IState, IConfigApplicationProps>(
    state => state.config.config,
  );

  return (
    <S.Container className="product-images-carousel">
      {freteGratis && (
        <img
          src="/images/card-icons/frete-gratis-tag.svg"
          alt="Frete Grátis"
          className="Selo frete-gratis"
          onClick={() => setShowModalAboutFreeFreight(true)}
        />
      )}

      <CardsList
        hovered={true}
        productSelos={productSelosSecondary}
        animationSelo="only-icon"
      />

      {seloCimed && (
        <img src="/images/card-icons/selo_cimed.svg" className="Selo CIMED" />
      )}

      {ultraDesconto && ultraDescontao.estaVigente && (
        <img
          src={ultraDescontao.seloVigenteVitrineUrl}
          className="Selo Ultradesconto"
        />
      )}

      <Swiper
        ref={swiperRef}
        modules={[Navigation, Pagination, Autoplay]}
        spaceBetween={50}
        slidesPerView={1}
        pagination={{ clickable: images.length > 1 ? true : false }}
        loop={images.length > 1}
        navigation={images.length > 1 ? true : false}
        speed={1000}
      >
        {images.map((item, index) => (
          <SwiperSlide key={index}>
            <img
              id={`product-image-${index}`}
              className="product-image"
              loading="lazy"
              src={item.grande}
              alt={productName}
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </S.Container>
  );
}
